import api from "./api";

// 取消生成任务
export async function cancelTaskCancel(taskId: string, type: number) {
  const res = await api.post<unknown>('/cancel_task/cancel', {
    task_id: taskId,
    type,
  });
  return res.data;
}
